import { render, staticRenderFns } from "./SenderProfileUpdate.vue?vue&type=template&id=cbb87600&scoped=true"
import script from "./SenderProfileUpdate.vue?vue&type=script&lang=js"
export * from "./SenderProfileUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb87600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
